export default __webpack_public_path__ + "6a24a65322772d525ef33de3ebfb4d3f.png";